document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile nav ─────────────────────────────────────── */
  var toggle = document.querySelector('.nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
      toggle.textContent = open ? '✕' : '☰';
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        toggle.textContent = '☰';
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Desktop dropdown ───────────────────────────────── */
  document.querySelectorAll('.nav-item-dropdown').forEach(function (item) {
    var trigger = item.querySelector(':scope > a');
    var menu = item.querySelector('.dropdown-menu');
    if (!trigger || !menu) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = menu.classList.contains('open');
      closeAllDropdowns();
      if (!isOpen) {
        menu.classList.add('open');
        trigger.classList.add('open');
      }
    });
  });

  function closeAllDropdowns() {
    document.querySelectorAll('.dropdown-menu.open').forEach(function (m) { m.classList.remove('open'); });
    document.querySelectorAll('.nav-item-dropdown > a.open').forEach(function (a) { a.classList.remove('open'); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-item-dropdown')) closeAllDropdowns();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  /* ── Abonnement selecteren via knop ─────────────────── */
  document.querySelectorAll('[data-pick-plan]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var plan = btn.getAttribute('data-pick-plan');
      var sel = document.getElementById('abonnement');
      if (sel) {
        sel.value = plan;
        var form = document.getElementById('reg-form') || document.getElementById('dienst-form');
        if (form) { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  });

  /* ── Diensten zoeken & filteren ─────────────────────── */
  var searchInput = document.getElementById('dienst-search');
  var catFilter = document.getElementById('cat-filter');
  var sortFilter = document.getElementById('sort-filter');
  var grid = document.getElementById('dienst-grid');
  var geenRes = document.getElementById('geen-resultaten');

  function filterDiensten() {
    if (!grid) return;
    var zoek = searchInput ? searchInput.value.toLowerCase() : '';
    var cat = catFilter ? catFilter.value : '';
    var kaarten = grid.querySelectorAll('.dienst-card');
    var zichtbaar = 0;
    kaarten.forEach(function (k) {
      var match = (!zoek || (k.dataset.naam || '').indexOf(zoek) !== -1) &&
                  (!cat  || (k.dataset.cat  || '') === cat);
      k.style.display = match ? '' : 'none';
      if (match) zichtbaar++;
    });
    if (geenRes) geenRes.style.display = zichtbaar === 0 ? 'block' : 'none';
  }

  if (searchInput) searchInput.addEventListener('input', filterDiensten);
  if (catFilter) catFilter.addEventListener('change', filterDiensten);
  if (sortFilter) {
    sortFilter.addEventListener('change', function () {
      if (!grid) return;
      var kaarten = Array.from(grid.querySelectorAll('.dienst-card'));
      var v = sortFilter.value;
      kaarten.sort(function (a, b) {
        if (v === 'prijs-laag') return (parseInt(a.dataset.prijs) || 0) - (parseInt(b.dataset.prijs) || 0);
        if (v === 'prijs-hoog') return (parseInt(b.dataset.prijs) || 0) - (parseInt(a.dataset.prijs) || 0);
        return 0;
      });
      kaarten.forEach(function (k) { grid.appendChild(k); });
    });
  }

  /* ── Live preview bij dienst aanmelden ──────────────── */
  function updatePreview() {
    var naam = document.getElementById('naam');
    var dienstnaam = document.getElementById('dienst-naam');
    var omschrijving = document.getElementById('omschrijving');
    var werkgebied = document.getElementById('werkgebied');
    var tarief = document.getElementById('tarief');
    var pNaam = document.getElementById('preview-naam');
    var pAanb = document.getElementById('preview-aanbieder');
    var pOmschr = document.getElementById('preview-omschrijving');
    var pWerk = document.getElementById('preview-werkgebied');
    var pTarief = document.getElementById('preview-tarief');

    if (naam && pAanb) {
      var s = naam.value || 'Jouw naam';
      if (werkgebied && werkgebied.value) s += ' — ' + werkgebied.value;
      pAanb.textContent = s;
    }
    if (dienstnaam && pNaam) pNaam.textContent = dienstnaam.value || 'Naam van je dienst';
    if (omschrijving && pOmschr) pOmschr.textContent = omschrijving.value || 'Je omschrijving verschijnt hier…';
    if (werkgebied && pWerk) pWerk.textContent = werkgebied.value || 'Jouw werkgebied';
    if (tarief && pTarief && tarief.value) {
      var vast = document.getElementById('optie-vast');
      var type = vast && vast.classList.contains('active') ? '/opdracht' : '/uur';
      pTarief.innerHTML = '€' + tarief.value + '<span>' + type + '</span>';
    }
  }
  window.updatePreview = updatePreview;

  /* ── Tarief type toggle ─────────────────────────────── */
  window.selectTarief = function (type) {
    var optUur = document.getElementById('optie-uur');
    var optVast = document.getElementById('optie-vast');
    if (optUur) optUur.classList.toggle('active', type === 'uur');
    if (optVast) optVast.classList.toggle('active', type === 'vast');
    var radios = document.querySelectorAll('[name="contact[TariefType]"]');
    radios.forEach(function (r) {
      r.checked = (type === 'uur' ? r.value === 'Uurtarief' : r.value === 'Vaste prijs');
    });
    updatePreview();
  };

  /* ── Live preview input listeners ──────────────────── */
  ['naam','dienst-naam','omschrijving','werkgebied','tarief'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('input', updatePreview);
  });

});
